<!-- src/components/ServiceCard.vue -->
<template>
    <div class="col">
        <div class="card text-white text-center bg-primary service-card">
            <div class="card-body">
                <i :class="['fa', icon, 'service-icon']"></i>
                <h4>{{ label }}</h4>
            </div>
        </div>
    </div>
</template>
  
<script>  
    export default {
        name: "ServiceCard",
        props: {
            icon: {
                type: String,
                required: true,
            },
            label: {
                type: String,
                required: true,
            },
        },
    };
</script>

<style scoped>
.service-card {
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    cursor: pointer;
}
.service-card:hover {
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}
.service-card i {
    font-size: 1.3rem;
}
.service-card h4 {
    font-size: 0.9rem;
}
</style>